import { useId } from 'react';
import styles from './Checkbox.module.css';
import { CheckboxProps } from './Checkbox.props';

export const Checkbox = ({ label, ...props }: CheckboxProps): JSX.Element => {
  const uid = useId();

  return (
    <label className={styles.wrapper} htmlFor={uid}>
      <input className={styles.input} type="checkbox" id={uid} {...props} />
      <span className={styles.track}>
        <span className={styles.thumb} />
      </span>
      {label && <span className={styles.label}>{label}</span>}
    </label>
  );
};
